export default __webpack_public_path__ + "static/media/Fanshawe College.jpg-2.653f43f8.png";